import { render, staticRenderFns } from "./Practicaltraining.vue?vue&type=template&id=2f592536&scoped=true&"
import script from "./Practicaltraining.vue?vue&type=script&lang=js&"
export * from "./Practicaltraining.vue?vue&type=script&lang=js&"
import style0 from "./Practicaltraining.vue?vue&type=style&index=0&id=2f592536&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f592536",
  null
  
)

export default component.exports